import { extend, localize } from "vee-validate";
import zh from "vee-validate/dist/locale/zh_CN.json";
import { required } from "vee-validate/dist/rules";
import i18n from "@/locales/i18n.ts";
import { VALIDATE_RULES } from "@/scripts/validator";

localize(i18n.locale, zh);

extend("required", {
    ...required,
    message: i18n.t("error.field_empty")
});

extend("phone", {
    validate(value) {
        return VALIDATE_RULES.phone(value);
    },
    message: i18n.t("error.phone_error")
});
